<div class="input-grid-gaps grid-1col">
    <app-select-input
        id="serviceToShareId"
        [form]="form"
        label="service.dataShare.fields.serviceToShare"
        [staticOptions]="store.availableServices()"
        [valueKey]="'id'">
    </app-select-input>
    <app-employment-type-select-input
        [form]="form"
        [multiselect]="true"
        id="employmentNames"
        label="service.dataShare.fields.employmentNames"
    />
    <app-check-input
        [form]="form"
        label="service.dataShare.fields.onlyMarkedFolders"
        id="onlyMarkedFolders"
    />
    <!--    will be used later -->
    <!--    <app-check-input-->
    <!--        [form]="form"-->
    <!--        label="service.dataShare.fields.onlyRead"-->
    <!--        id="onlyRead"-->
    <!--    />-->
    <app-multi-select-input
        [form]="form"
        [staticOptions]="folderDashboardWidgetsEnumOptionsToShare()"
        valueKey="value"
        label="service.dataShare.fields.widgets"
        id="widgets"
        display="comma"
    ></app-multi-select-input>
</div>
